/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown>, oldPrice: NonNullable<unknown>, newPrice: NonNullable<unknown> }} Sub_Upgrade_Seats_NoteInputs */



/**
* | output |
* | --- |
* | "Seats increase from {from} to {to} (billing floor). Per-user price drops from {oldPrice} to {newPrice}." |
*
* @param {Sub_Upgrade_Seats_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_upgrade_seats_note = /** @type {((inputs: Sub_Upgrade_Seats_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Upgrade_Seats_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Plätze erhöhen sich von ${i?.from} auf ${i?.to} (Abrechnungsminimum). Der Preis pro Nutzer sinkt von ${i?.oldPrice} auf ${i?.newPrice}.`)
	return /** @type {LocalizedString} */ (`Seats increase from ${i?.from} to ${i?.to} (billing floor). Per-user price drops from ${i?.oldPrice} to ${i?.newPrice}.`)
});